import { Component } from '@angular/core';
import { formatDate } from '@angular/common';
import { NgForm } from '@angular/forms';
import { BordereauService } from '../../../bordereau/bordereau.service';

@Component({
  selector: 'app-equine-report',
  templateUrl: './equine-report.component.html',
  styleUrls: ['./equine-report.component.css']
})
export class EquineReportComponent {
  activeTab = 'master';

  masterStartDate = '';
  masterEndDate = '';
  transactedStartDate = '';
  transactedEndDate = '';
  paidStartDate = '';
  paidEndDate = '';

  constructor(private bordereauService: BordereauService) {}

  onSubmit(f: NgForm, reportType: string): void {
    if (!f.valid) {
      return;
    }

    let startDate = '';
    let endDate = '';
    let fileName = '';

    switch (reportType) {
      case 'master':
        startDate = this.masterStartDate;
        endDate = this.masterEndDate;
        fileName = 'equine-master-bdx.xlsx';
        break;
      case 'transacted':
        startDate = this.transactedStartDate;
        endDate = this.transactedEndDate;
        fileName = 'equine-transacted-bdx.xlsx';
        break;
      case 'paid':
        startDate = this.paidStartDate;
        endDate = this.paidEndDate;
        fileName = 'equine-paid-bdx.xlsx';
        break;
    }

    const data = {
      start_date: formatDate(startDate, 'yyyy-MM-dd', 'en-US'),
      end_date: formatDate(endDate, 'yyyy-MM-dd', 'en-US'),
      report_type: reportType
    };

    this.bordereauService.policyEquine(data).subscribe(
      (response: any) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      },
      (error) => {
        console.error('Error downloading report:', error);
      }
    );
  }
}
